import { Pipe, PipeTransform } from "@angular/core";
import { ShipViaOption } from '../../api/models/order-detail';
@Pipe({
    name: 'sortShipViaOptions'
})
export class ShipViaOptionsSort implements PipeTransform {
    shipViaCodeInOrder = ['01', '02', '03', '05', '48', '00', 'U7', 'PU', 'P1', '31', '32', '33', '35', 'RE', 'CC']
    transform(values: ShipViaOption[]): ShipViaOption[] {
        return values.sort((a, b) => {
            if(this.shipViaCodeInOrder.indexOf(a.code) < this.shipViaCodeInOrder.indexOf(b.code)) {
                return -1;
            } else {
                return 1;
            }
        });
    }
}


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/checkout/sort-ship-via-options.pipe.ts